export function PocBanner() {
  return (
    <div
      role="status"
      className="bg-amber-100 text-amber-950 dark:bg-amber-950 dark:text-amber-50 px-4 py-2 text-sm text-center"
    >
      This is a POC. Design is not frozen.
    </div>
  );
}
